import React, { useCallback, useContext, useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';

import { Button, Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions} from '@material-ui/core';
import { MuiRouterLink } from '../CustomMui';
import { useSelector } from 'react-redux';
import LockContext from '../../contexts/LockContext';

// Dialog that displays when user navigates away from this component
export const ConfirmNavigation = (props) => {
  const history = useHistory();
  const editorDirty = useSelector(state => state.dirty);
  const { lock } = useContext(LockContext); 

  const [open, setOpen] = useState(false);
  const [dirty, setDirty] = useState(true);
  const [next, setNext] = useState(null);

  const handleClose = () => {
    setDirty(true)
    setOpen(false);
  };

  useEffect(() => {
    if (!lock.isCurrent) {
      setDirty(false)
    } else {
      setDirty(editorDirty)
    }
  }, [editorDirty,lock.isCurrent])

  // unblock is the RETURN value for the history.block function;
  // must be return value of useCallback also
  const unblock = useCallback(() => (
    history.block((nextLocation) => { 
      const { state = {} } = nextLocation;
      
      // Allow router to pass a condition that bypasses this component
      if (state.dirty === false) {
        return true;
      }
      if (dirty) {
        // open dialog
        setOpen(true);
        // unblock for next try
        setDirty(false)
        // keep record of where user was trying to go
        setNext(nextLocation)
      }
      return !dirty;
    })), [dirty, history])

  // On unmount, unblock the component and display the dialog
  useEffect(() => {
    return unblock()
  }, [unblock])
  
  return (
    <Dialog
      open={open}
      onClose={handleClose}
      aria-labelledby="confirm-nav-title"
      aria-describedby="confirm-nav-description"
    >

      <DialogTitle id="confirm-nav-title">{"Are you sure you want to leave this page?"}</DialogTitle>
      
      <DialogContent>
        <DialogContentText id="confirm-nav-description" component="div">
          Any unsaved edits will be lost.
        </DialogContentText>
      </DialogContent>

      <DialogActions>

        <Button onClick={handleClose} variant="text">
          Cancel
        </Button>

        {next ? 
          <Button component={MuiRouterLink} to={next.pathname} color="primary" autoFocus>
            Yes, leave page
          </Button>
        : '' }
        
      </DialogActions>

    </Dialog>
  )
  
}